import Route from '@ember/routing/route';
import { action, get } from '@ember/object';
import { hash } from 'rsvp';
import { inject as service } from '@ember/service';
import { routeEvent } from 'garaje/utils/decorators/route';

class VisitorsSettingsLocationRoute extends Route {
  @service abilities;
  @service state;
  @service transitionConfirm;
  @service router;
  @service('global-setting-batch') globalSettingBatchService;
  @service store;
  @service featureFlags;

  titleToken = 'Account Settings';

  beforeModel() {
    if (this.abilities.cannot('visit advance-settings')) {
      if (this.abilities.can('visit security')) {
        this.router.transitionTo('security');
      } else if (this.abilities.can('visit billing')) {
        this.router.transitionTo('billing');
      } else {
        this.router.transitionTo('unauthorized');
      }
    }
  }

  async model() {
    const currentLocationId = this.modelFor('current-location').id;
    const currentLocation = await this.store.findRecord('location', currentLocationId, { reload: true });
    const company = get(currentLocation, 'company');
    const { ipads } = this.modelFor('visitors.settings');
    const { vrSubscription } = this.state;
    let groups = [];
    if (this.abilities.can('propagate global-setting-batch')) {
      const globalSettingBatchService = this.globalSettingBatchService;
      globalSettingBatchService.createGlobalSettingBatch({ parent: currentLocation });
    }
    if (this.abilities.can('view locations-grouping')) {
      groups = this.store.findAll('group');
    }

    return hash({
      currentLocation,
      company,
      ipads,
      vrSubscription,
      groups,
    });
  }

  setupController(controller, { currentLocation }) {
    super.setupController(...arguments);
    controller._buildChangeset(currentLocation);
  }

  @action
  backToLocation() {
    this.router.transitionTo('visitors.settings.location');
  }

  @routeEvent
  routeWillChange(transition) {
    const controller = this.controller;
    const isDirty = get(controller, 'isDirty');

    // no need to display confirmation modal when nothing is changed
    if (!isDirty) {
      return;
    }

    // display confirmation modal if the form is dirty
    this.transitionConfirm.displayConfirmTask.perform(transition, {
      continue() {
        if (isDirty) {
          controller.rollback();
        }
      },
    });
  }
}

export default VisitorsSettingsLocationRoute;
